export default __webpack_public_path__ + "static/media/my-logo.e33ef25d.svg";